import { FC } from 'react';
import Slider, { CustomArrowProps, Settings } from 'react-slick';
import { ICustomerReview } from './types';
import ReviewCard from './ReviewCard';
import styled from 'styled-components';
import { LeftCircleFilled, RightCircleFilled } from '@ant-design/icons';

const StyledSlider = styled.div`
  .slider-arrows {
    top: calc(100% + 20px) !important;
    position: absolute;
    &::before {
      display: none;
    }

    display: none !important;

    @media screen and (min-width: ${(props) => props.theme.metrics.breakpoints.md}) {
      top: calc(100% + 20px) !important;
      display: block !important;
    }
  }
  .slick-list {
    padding-top: 32px !important;
    padding-bottom: 32px !important;
  }

  .slick-dots {
    button:before {
      color: #d3d3d3;
      opacity: 1;
    }
    li {
      margin: 0;
    }
    .slick-active button:before {
      color: ${(props) => props.theme.color.primaryBase};
      opacity: 1;
    }
  }
`;

const StyledArrow = styled.div`
  display: block;
  width: 40px !important;
  height: 40px !important;
  text-align: center;

  svg {
    background: ${(props) => props.theme.color.background};
    color: ${(props) => props.theme.color.primaryBase};
    font-size: 40px;
    border-radius: 40px;
  }
`;

export const StyledNextArrow = styled(StyledArrow)`
  right: 55px !important;
  z-index: 2;
`;

export const StyledPrevArrow = styled(StyledArrow)`
  left: 55px !important;
  z-index: 2;
`;

const PrevArrow: FC = (props: CustomArrowProps): JSX.Element => {
  const { className, style, onClick } = props;
  return (
    <StyledPrevArrow
      className={`${className} slider-arrows`}
      style={{ ...style }}
      onClick={onClick}
      role="button"
      aria-label="Previous review"
    >
      <LeftCircleFilled aria-hidden="true" />
    </StyledPrevArrow>
  );
};

const NextArrow: FC = (props: CustomArrowProps): JSX.Element => {
  const { className, style, onClick } = props;
  return (
    <StyledNextArrow
      className={`${className} slider-arrows`}
      style={{ ...style }}
      onClick={onClick}
      role="button"
      aria-label="Next review"
    >
      <RightCircleFilled aria-hidden="true" />
    </StyledNextArrow>
  );
};

interface ReviewSliderProps {
  reviews: ICustomerReview[];
}

const ReviewSlider: FC<ReviewSliderProps> = ({ reviews }) => {
  const settings: Settings = {
    infinite: true,
    dots: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    variableWidth: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
  };

  return (
    <StyledSlider>
      <Slider {...settings}>
        {reviews.map((item: ICustomerReview, index) => (
          <div key={`${item.review}-${index}`}>
            <ReviewCard key={`${item.review}-${index}`} content={item} />
          </div>
        ))}
      </Slider>
    </StyledSlider>
  );
};

export default ReviewSlider;
